import React, { useMemo } from "react";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/sagas/funnelChart";
import { useDispatch, useSelector } from "react-redux";
import FUNNEL_CONSTANTS from "../constants";

export const LocationsAverageFilter = () => {
  const dispatch = useDispatch();

  const average = useSelector((state) => state.laser.selectedFilters.average);
  const selectedSubAverageFilterOptions = useSelector(
    (state) => state.laser.selectedFilters.subAverageFilterOptions
  );
  const selectedAverageLocations = useSelector(
    (state) => state.laser.selectedFilters.selectedAverageLocations
  );

  const availableLocations = useMemo(
    () => selectedAverageLocations,
    [selectedSubAverageFilterOptions]
  );

  if (average !== FUNNEL_CONSTANTS.USER_ACCESS || !availableLocations.length) return null;

  return (
    <div className="select-box" style={{ width: "150px" }}>
      <p className="offers-title">Locations (Average)</p>
      <MultiSelectDropdown
        options={availableLocations}
        selectedFilters={selectedAverageLocations}
        onSelectChange={(data) => dispatch(actionCreators.setAverageLocations(data))}
        enableOnly
        numberDisplayed={0}
        includeSelectAll
        haveOnSelectChange
      />
    </div>
  );
};
